export default __webpack_public_path__ + "static/avatar_3-d6979b1e8b3d503fb7f9e2ea4665d3c9.svg";